import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/observable';

import { Member } from '../models/member';

@Injectable()
export class MemberService {

	constructor(private afDatabase: AngularFireDatabase) { }

	public getMembers(): Observable<Member[]> {
		return this.afDatabase.list('/members');
	}

	public getMember(key: string): Observable<Member> {
		return this.afDatabase.object(`/members/${key}`);
	}

	public async addMember(member: Member): Promise<string> {
		const date = new Date();
		member.createdAt = date.getTime();
		member.updatedAt = date.getTime();

		return this.afDatabase.list('/members').push(member).then(res => {
			return res;
		});
	}

	public async updateMember(key: string, member: Member): Promise<any> {
		const date = new Date();
		member.updatedAt = date.getTime();

		return this.afDatabase.object(`/members/${key}`).update(member) as Promise<any>;
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/member.service.ts